import { render, staticRenderFns } from "./submenu-item.vue?vue&type=template&id=6817441a&"
import script from "./submenu-item.component.ts?vue&type=script&lang=ts&"
export * from "./submenu-item.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6817441a')) {
      api.createRecord('6817441a', component.options)
    } else {
      api.reload('6817441a', component.options)
    }
    module.hot.accept("./submenu-item.vue?vue&type=template&id=6817441a&", function () {
      api.rerender('6817441a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/application-dictionary/components/TreeView/submenu-item.vue"
export default component.exports